import {
    Box, Button, Grid, Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { callAPI, clearRequest, customValidation, LoacalVariables, Method, setLocalValues, validations } from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSTextBoxWithOtp from "../../Components/TextBox/WSTextBoxWithOtp";
import backgroundImage from '../../images/bg2.svg';
import logo from '../../images/melplogo1.svg';
import backgroundImage1 from '../../images/Rectangle.svg';
import WSSelectField from "../../Components/Select/WSSelect";
import config from "../../Config/clientConfig.json";


export const RegisterForm = () => {
    const { control, register, handleSubmit, formState: { errors }, getValues, reset, watch } = useForm();
    const { showMessage } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [disbaleButton, setDisableButton] = useState(true);
    const [isVerified, setIsVerified] = useState(false);
    const [phoneNumber, setPhone] = useState<any>();
    const [isOtpSend, setIsOtpSend] = useState(false);
    const [pageIndex, setPageIndex] = useState(0);
    const [userName, setUserName] = useState<any>();
    const navigate = useNavigate();
    useEffect(() => {
        reset()

    }, [])
    const handleData = async (data: any) => {
        try {
            setUserName(data)
            setPageIndex(1)
        } catch (e: any) {
            showMessage(e.message || "An unexpected error occurred.", "error");
        } finally {
            setLoading(false);
        }
    };
    const onSubmit = async (data: any) => {
        try {
            const request = {
                name: userName?.name,
                phoneNumber: userName?.mobileNumber,
                password: data.password,
                // userType: "vendor",
                userType:data.userType,
                userCode: data?.userCode,
                email: data?.email,
                deviceToken: "",
            };
            const newRequest = clearRequest(request);
            setLoading(true);
            const response = await callAPI("Auth/register", Method.POST, newRequest);
            if (response?.isSuccess) {
                localStorage.setItem('phoneNumber', userName?.mobileNumber)
                setLocalValues(LoacalVariables.Name, userName?.name);
                setLocalValues(LoacalVariables.UserId, response?.data?.id);
                localStorage.setItem('email', data?.email)

                showMessage("Registered successfully!", "success");
                navigate('/register/profile')
            } else {
                throw new Error("Registration failed.");
            }
        } catch (e: any) {
            showMessage(e.message || "An unexpected error occurred.", "error");
        } finally {
            setLoading(false);
        }
    };
    const handleSendOtp = async (phone: string) => {
        setPhone(phone)
        try {
            const response: any = await callAPI('Otp/generate', Method.POST, { phoneNumber: '91' + phone });
            if (response) {
                setIsOtpSend(response?.success)
                showMessage(response?.message, response?.success ? 'success' : "error");

            }
        } catch (error) {

        }

    }
    const handleVerify = async (code: string) => {

        setIsVerified(true)
        try {
            const response: any = await callAPI('Otp/verify', Method.POST, { phoneNumber: '91' + phoneNumber, code: code });

            if (response) {
                showMessage(response?.message, response?.success ? 'success' : "error");
                setIsVerified(response?.success)
                setDisableButton(!response?.success)
            }
        } catch (error) {

        }

    }
    return (

        <Grid
            container
            sx={{
                position: 'relative',
                minHeight: '100vh',
                backgroundImage: `url(${backgroundImage1})`,

                backgroundSize: 'cover',
                backgroundColor: '#022219',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',

                justifyContent: 'center',
                alignItems: 'center',
                padding: 2,
            }}
        >
            <Box
                component="img"
                src={logo}
                alt="MELP Logo"
                sx={{
                    position: 'absolute',
                    top: 24,
                    left: 54,
                    width: 100,
                    zIndex: 10,
                }}
            />
            <Grid container sx={{
                position: 'relative',
                minHeight: '80vh',
                backgroundImage: `url(${backgroundImage})`,
                border: '1px solid #022219',
                borderRadius: 5,
                backgroundSize: 'cover',
                backgroundColor: '#022219',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                width: '80%',
                padding: 7,
            }}>


                {/* Registration Form Box */}
                <Box
                    sx={{
                        backgroundColor: 'white',
                        padding: 4,
                        borderRadius: 4,
                        maxWidth: 500,
                        width: '100%',
                        boxShadow: 3,
                    }}


                >
                    <Typography variant="h5" fontWeight="bold" color="#004d40" textAlign="center">
                        Join Our Mission to Make <br />
                        <Box component="span" color="green">Healthcare</Box>{' '}
                        <Box component="span" color="#FBC02D">Accessible</Box>
                    </Typography>

                    <Typography variant="subtitle2" color="textSecondary" mt={1} mb={3} textAlign="center">
                        Create Your Business Account
                    </Typography>
                    {pageIndex === 0 && <form onSubmit={handleSubmit(handleData)}>
                        <Grid container spacing={2}>
                            <Grid item sm={12} xs={12}>
                                <WSTextField control={control} id="name" name="name" rules={{ required: true }} label="Name *"></WSTextField>

                            </Grid>
                            
                            {/* Mobile Number with OTP */}
                            <Grid item xs={12}>
                                <WSTextBoxWithOtp
                                    id="phone"
                                    name="mobileNumber"
                                    label="Mobile Number"
                                    rules={{ required: true }}
                                    control={control}
                                    type={TextType.AllowOnlyNumber}
                                    maxLength={10}
                                    showPhonePrefix
                                    getValues={getValues}
                                    sendOtpAction={handleSendOtp}
                                    sendOtpText="Send OTP"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="caption" color="textSecondary">
                                    One Time Password (OTP) will be sent to entered Mobile Number
                                </Typography>
                            </Grid>
                            {/* showPin &&  */}
                            {isOtpSend && <Grid item xs={12}>
                                <WSTextBoxWithOtp
                                    id="userCode1"
                                    name="userCode1"
                                    label="Enter Pin"
                                    rules={{ required: true }}

                                    control={control}
                                    type={TextType.AllowOnlyNumber}
                                    maxLength={6}
                                    showPhonePrefix={false}
                                    getValues={getValues}
                                    sendOtpAction={handleVerify}
                                    sendOtpText="Verify"
                                    isVerified={isVerified}
                                />
                                {/* <WSTextField
                                    label="Enter Pin"
                                    rules={{ required: true }}
                                    id="userCode"
                                    name="userCode"
                                    control={control}
                                    maxLength={6}
                                    type={TextType.Otp}

                                /> */}
                            </Grid>}


                            {/* Password */}
                            <Grid item xs={12}>
                                <WSTextField
                                    label="Create Password"
                                    {...register("password", { required: "Password is required" })}
                                    id="password"
                                    name="password"
                                    control={control}
                                    type={TextType.Password}
                                />
                            </Grid>

                           

                            <Grid item xs={12}>
                                <Typography variant="caption" color="textSecondary">
                                    Minimum 8 chars, at least one number & one special char (@#$%^&*)
                                </Typography>
                            </Grid>

                            {/* Sign In Link */}
                            <Grid item xs={12}>
                                <Typography variant="body2" color="textSecondary" textAlign="center">
                                    Already a registered partner?{' '}
                                    <Link to="/login" style={{ textDecoration: 'none', color: '#098963', fontWeight: 500 }}>
                                        Sign In
                                    </Link>
                                </Typography>
                            </Grid>

                            {/* Register Button */}
                            <Grid item xs={12}>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    sx={{
                                        backgroundColor: "#098963",
                                        color: "white",
                                        paddingY: "10px",
                                        fontWeight: "bold",
                                        borderRadius: "8px",
                                        '&:hover': {
                                            backgroundColor: "#056e4e",
                                        },
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? "Registering..." : "Register"}
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                    }
                    {pageIndex === 1 && <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2}>
                            <Grid item sm={12} xs={12}>
                                <WSTextField control={control} id="name" name="name" rules={{ required: true }} disabled label="Name *"></WSTextField>

                            </Grid>
                            {/* Mobile Number with OTP */}
                            <Grid item sm={6} xs={12}>
                                <WSTextField control={control} id="email" {...register('email')} name="email" rules={customValidation(true, validations.email)} label="Email *"></WSTextField>
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <WSTextField control={control} id="userCode" rules={{ required: true }} minLength={6} maxLength={6} type={TextType.AllowOnlyNumber} name="userCode" label="PIN" ></WSTextField>
                            </Grid>
                             <Grid item xs={12}>
                    <WSSelectField
                      rules={{ required: true }}
                      {...register("loginType")}
                      id="userType"
                      control={control}
                      label="Login Type"
                      name="userType"
                      isInGridFilter={false}
                      options={config.loginTypeConfig.staticOptionData}
                      defaultValue={"Lab"}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                    />
                  </Grid>

                            {<Grid item sm={6} xs={12}>
                                <WSTextField control={control} id="password"  {...register("password", {
                                    required: true,
                                    validate: (value: any) => {
                                        const password = watch("confirmPassword");
                                        return value === password || "Passwords do not match";
                                    },
                                })} name="password" label="Password *" type={TextType.Password}></WSTextField>
                            </Grid>}


                            {<Grid item sm={6} xs={12}>
                                <WSTextField control={control} id="confirmPassword" {...register("confirmPassword", {
                                    required: true,
                                    validate: (value: any) => {
                                        const password = watch("password");
                                        return value === password || "Passwords do not match";
                                    },
                                })} label="Confirm Password *" type={TextType.Password}></WSTextField>
                            </Grid>}


                            {/* Sign In Link */}
                            <Grid item xs={12}>
                                <Typography variant="body2" color="textSecondary" textAlign="center">
                                    Already a registered partner?{' '}
                                    <Link to="/login" style={{ textDecoration: 'none', color: '#098963', fontWeight: 500 }}>
                                        Sign In
                                    </Link>
                                </Typography>
                            </Grid>

                            {/* Register Button */}
                            <Grid item xs={12}>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    sx={{
                                        backgroundColor: "#098963",
                                        color: "white",
                                        paddingY: "10px",
                                        fontWeight: "bold",
                                        borderRadius: "8px",
                                        '&:hover': {
                                            backgroundColor: "#056e4e",
                                        },
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? "Registering..." : "Register"}
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                    }
                </Box>
            </Grid>
        </Grid>

    );
};
